import { GameCreativeDetailsData, GenreCreativeAggregate } from '../types'

/**
 * Wraps a `GenreCreativeAggregate` in a `GameCreativeDetailsData`-shaped
 * object so the per-game compare components (which take `source` and `target`
 * as `GameCreativeDetailsData`) can render with a genre on the target side
 * without bespoke branches.
 *
 * Synthetic fields:
 *  - `game.id` is the genre id — ids are ObjectIds, unique across entities, so
 *    an "is this the same game?" check downstream cannot collide with a game.
 *  - `game.icon` is omitted — consumers already guard on its presence.
 *  - `motivationScores.gameDesign` is omitted — no in-game profile exists for
 *    genres; matches the convention used for games without a profile on file.
 *  - `motivationDiagnosis` is empty — nothing on the Creative Tags / Overview
 *    tabs consumes the diagnosis, but the field is required by the type.
 *
 * Unlike a real game's name, the genre standing in for one is display copy, so
 * the caller passes the already-localised label rather than letting the
 * aggregate's English `genre.name` reach the compare headings.
 */
export function genreAsGameLike(aggregate: GenreCreativeAggregate, genreLabel: string): GameCreativeDetailsData {
  return {
    game: {
      id: aggregate.genre.id,
      name: genreLabel,
      genre: aggregate.genre,
    },
    motivationScores: {
      creativeAds: aggregate.creativeAdsMotivations,
    },
    motivationDiagnosis: { aligned: [], blindSpots: [] },
    tags: aggregate.tags,
    creativeAds: aggregate.creativeAds,
    scopeMaxInstallShare: aggregate.scopeMaxInstallShare,
  }
}
